import {useMsal} from "@azure/msal-react";
import Forbidden from "../../Pages/Forbidden/Forbidden";

type Props = {
    children: JSX.Element,
    enabled?: boolean,
    roleName: string
}

const AppRoleChecker = (props: Props) => {
    const { accounts } = useMsal();
    
    let enabled = props.enabled ?? true;
    let accessOk : boolean = (enabled && accounts && accounts[0] && accounts[0]?.idTokenClaims && accounts[0]?.idTokenClaims["roles"] &&
        (accounts[0]?.idTokenClaims["roles"] as Array<string>).includes(props.roleName))?? false;
    
    
    return (
        enabled ?
            accessOk ?
                props.children:
                <Forbidden />
            :
            props.children
    );
}

export default AppRoleChecker;